var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pb-30" }, [
    _c("div", { staticClass: "head-banner mb-30" }, [
      _c("h1", { staticClass: "banner-absolute" }, [
        _vm._v(_vm._s(_vm.platInfo.name)),
      ]),
      _c("h2", { staticClass: "banner-absolute" }, [_vm._v("招标采购")]),
      _c("div", { staticClass: "slogan banner-absolute" }, [
        _vm._v("信息透明 · 交易规范 · 高速高效 · 安全稳定"),
      ]),
    ]),
    _c("div", { staticClass: "def-w" }, [
      _c("div", { staticClass: "filter-content" }, [
        _c("div", { staticClass: "filter-list" }, [
          _c("div", { staticClass: "filter-item flex" }, [
            _c("span", { staticClass: "filter-label" }, [_vm._v("项目类型:")]),
            _c(
              "ul",
              { staticClass: "flex filter-option-list" },
              _vm._l(_vm.projectTypeList, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "filter-option",
                    class: { active: item.code === _vm.searchForm.projectType },
                    on: {
                      click: function ($event) {
                        return _vm.selectFilter("projectType", item.code)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.label) + " ")]
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "filter-item flex" }, [
            _c("span", { staticClass: "filter-label" }, [_vm._v("公告类型:")]),
            _c(
              "ul",
              { staticClass: "flex filter-option-list" },
              _vm._l(_vm.noticeTypeList, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "filter-option",
                    class: { active: item.code === _vm.searchForm.noticeType },
                    on: {
                      click: function ($event) {
                        return _vm.selectFilter("noticeType", item.code)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.label) + " ")]
                )
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "filter-item flex" }, [
            _c("span", { staticClass: "filter-label" }, [_vm._v("项目状态:")]),
            _c(
              "ul",
              { staticClass: "flex filter-option-list" },
              _vm._l(_vm.statusList, function (item, index) {
                return _c(
                  "li",
                  {
                    key: index,
                    staticClass: "filter-option",
                    class: { active: item.code === _vm.searchForm.status },
                    on: {
                      click: function ($event) {
                        return _vm.selectFilter("status", item.code)
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(item.label) + " ")]
                )
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "filter-total flex align-center" }, [
          _c("span", { staticClass: "color-666" }, [
            _vm._v("当前记录 "),
            _c("em", { staticClass: "color-theme-red" }, [
              _vm._v(_vm._s(_vm.total)),
            ]),
            _vm._v(" 条"),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "list-content" },
        [
          _vm.list.length || _vm.loading
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "projectTableRef",
                  staticClass: "project-table",
                  attrs: {
                    data: _vm.list,
                    fit: "",
                    "default-sort": { prop: "endTime", order: null },
                    "header-cell-style": _vm.headerCellStyle,
                    "cell-style": _vm.cellStyle,
                  },
                  on: {
                    "sort-change": _vm.handleSortChange,
                    "row-click": _vm.rowClick,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "项目名称", "min-width": "180" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "text-cut",
                                  attrs: { title: scope.row.gonggaoTitle },
                                },
                                [_vm._v(_vm._s(scope.row.gonggaoTitle))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3797241240
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "purchaseWayName",
                      label: "采购方式",
                      width: "180",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "endTime",
                      label: "截止时间",
                      width: "160",
                      sortable: "custom",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "120" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass: "table-btn",
                                  style: {
                                    backgroundColor: ["1", "3"].includes(
                                      scope.row.status
                                    )
                                      ? "#DC4B19"
                                      : "#999",
                                  },
                                },
                                [_vm._v(_vm._s(scope.row.status_name))]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1616409830
                    ),
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticStyle: { height: "450px" } },
                [_c("no-data")],
                1
              ),
          _c(
            "el-pagination",
            {
              staticClass: "table-pagination flex-center",
              attrs: {
                "hide-on-single-page": "",
                background: "",
                "current-page": _vm.curPage,
                "page-size": _vm.pageSize,
                "pager-count": 5,
                "prev-text": "上一页",
                "next-text": "下一页",
                layout: " prev, pager, next, slot",
                total: _vm.total,
              },
              on: { "current-change": _vm.handleCurrentChange },
            },
            [
              _c("div", { staticClass: "flex align-center color-666" }, [
                _c("div", [
                  _vm._v(
                    "共" +
                      _vm._s(_vm.curPage) +
                      "页/共" +
                      _vm._s(_vm.total) +
                      "条数据"
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "flex-center ml-20" },
                  [
                    _c("p", [_vm._v("转到")]),
                    _c("el-input-number", {
                      staticClass: "page-input",
                      attrs: {
                        controls: false,
                        min: 1,
                        max: _vm.maxPage,
                        step: 1,
                        "step-strictly": "",
                      },
                      model: {
                        value: _vm.curSdPage,
                        callback: function ($$v) {
                          _vm.curSdPage = $$v
                        },
                        expression: "curSdPage",
                      },
                    }),
                    _c("p", { staticClass: "ml-5" }, [_vm._v("页")]),
                    _c(
                      "el-button",
                      {
                        staticClass: "jump-btn",
                        on: {
                          click: function ($event) {
                            return _vm.handleCurrentChange(_vm.curSdPage)
                          },
                        },
                      },
                      [_vm._v("确定")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }